<template>
  <div>
    <v-btn
        v-if="userType === 'students' && tab == 0 && mode === 'advanced'"
        class="mr-2"
            color="success"
            @click="openRouteSelectionDialog(-1,1)"
            :disabled="isLoading || selected_student_ids.length===0"
        >
            <v-icon class="me-2">mdi-location-enter</v-icon>
            <span> Set Pickup</span>
    </v-btn>
    <v-btn
        v-if="userType === 'students' && tab == 0 && mode === 'advanced'"
        class="mr-2"
            color="success"
            @click="openRouteSelectionDialog(-1,0)"
            :disabled="isLoading || selected_student_ids.length===0"
        >
            <v-icon class="me-2">mdi-location-exit</v-icon>
            <span> Set Dropoff</span>
    </v-btn>
    <v-data-table
        v-model="selected_students"
        item-key="id"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :headers="getHeader()"
        :items="users"
        :show-select="userType === 'students' && tab<2"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Αναζήτηση"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.status_id="{ item }">
          <v-chip
            :color="getStatusColor(item.status_id)"
            dark
          >
            {{ getStatusValue(item.status_id) }}
          </v-chip>
        </template>

        <template v-slot:item.name="{ item }">
            {{item.name}}
            <v-tooltip v-if="item.expired != null && item.expired"  bottom color="info">
                <template v-slot:activator="{ on }">
                <v-icon color="error" v-on="on">
                    mdi-cancel
                </v-icon>
                </template>
                <span>Ένα ή περισσότερα από τα έγγραφα του οδηγού έχουν λήξει</span>
            </v-tooltip>
        </template>
        <template v-if="userType === 'guardians'" v-slot:item.role_id="{ item }">
                    <v-chip
                        dark
                        :color="item.role_id === 4? 'primary' : 'info'"
                    >
                        {{ item.role_id === 4? 'Γονέας' : 'Κηδεμόνας' }}
                    </v-chip>
        </template>
        <template v-if="userType === 'drivers'" v-slot:item.bus="{ item }">
          <v-chip
            dark
            @click="$emit('assignBus', item)"
            :color="getBusAssignmentColor(item.bus)"
          >
            {{ item.bus != null? item.bus.license : 'No bus' }}
          </v-chip>
        </template>

        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment("LL") }}</small> -
          <small class="text-muted">{{ item.created_at | moment("LT") }}</small>
        </template>
        <template v-slot:item.student_settings.morning_bus="{ item }">
          <v-tooltip v-if="tab<2 && userType === 'students' && mode === 'simple'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    dark
                    @click="$emit('set-student-bus', item, 1)"
                    :color="getBusAssignmentColor(item.student_settings.morning_bus)"
                >
                    {{ item.student_settings.morning_bus != null? item.student_settings.morning_bus.license : 'No bus' }}
                </v-chip>
            </template>
            <span>Ανάθεση σε πρωινό σχολικό</span>
          </v-tooltip>
        </template>
        <template v-slot:item.student_details.pickup_stop="{ item }">
          <v-tooltip v-if="tab==0 && userType === 'students' && mode === 'advanced'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-card v-if="item.student_details == null || item.student_details.pickup_stop == null" v-bind="attrs" v-on="on" class="ma-2" outlined color="error" @click="openRouteSelectionDialog(item.id, 1)">
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-content><small>Χωρίς ανάθεση</small></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
                <v-card v-else v-bind="attrs" v-on="on" class="ma-2" outlined color="success" @click="openRouteSelectionDialog(item.id, 1)">
                    <!-- @click="$emit('set-student-bus', item, 0)" -->
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-road-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.pickup_route.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-map-marker</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.pickup_stop.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.student_details.pickup_pick_time">
                            <v-list-item-icon>
                                <v-icon small>mdi-bus-clock</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <small>{{ tConvert(item.student_details.pickup_pick_time) }}</small>
                                </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </template>
            <span>Ανάθεση σε απογευματινό</span>
          </v-tooltip>
        </template>
        <template v-slot:item.student_details.drop_off_stop="{ item }">
          <v-tooltip v-if="tab==0 && userType === 'students' && mode === 'advanced'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-card v-if="item.student_details == null || item.student_details.drop_off_stop == null" v-bind="attrs" v-on="on" class="ma-2" color="error" outlined @click="openRouteSelectionDialog(item.id, 0)">
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-content><small>Χωρίς ανάθεση</small></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
                <v-card v-else v-bind="attrs" v-on="on" class="ma-2" outlined color="success" @click="openRouteSelectionDialog(item.id, 0)">
                    <v-list density="compact" disabled>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-road-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.drop_off_route.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-map-marker</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content><small>{{ item.student_details.drop_off_stop.name }}</small></v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.student_details.drop_off_drop_time">
                            <v-list-item-icon>
                                <v-icon small>mdi-bus-clock</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <small>{{ tConvert(item.student_details.drop_off_drop_time) }}</small>
                                </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </template>
            <span>Ανάθεση σε απογευματινό σχολικό</span>
          </v-tooltip>
        </template>
        <template v-slot:item.student_settings.afternoon_bus="{ item }">
          <v-tooltip v-if="tab<2 && userType === 'students' && mode === 'simple'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    dark
                    @click="$emit('set-student-bus', item, 0)"
                    :color="getBusAssignmentColor(item.student_settings.afternoon_bus)"
                >
                    {{ item.student_settings.afternoon_bus != null? item.student_settings.afternoon_bus.license : 'No bus' }}
                </v-chip>
            </template>
            <span>Ανάθεση σε απογευματινό σχολικό</span>
          </v-tooltip>
        </template>


        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="tab==2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                class="mr-2 primary"
                @click="$emit('view-user', item)"
              >
                <v-icon small class="mr-2">
                  mdi-card-account-mail-outline
                </v-icon>
                Επιλογή
              </v-btn>
            </template>
            <span>Εγκριση η απόρριψη</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('view-user', item)">
                mdi-eye
              </v-icon>
            </template>
            <span>Προβολή</span>
          </v-tooltip>
          <v-tooltip v-if="tab==0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="checkIfLocationEnabled(item) && mode === 'simple'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('show-student-location', item)">
                mdi-map-marker
              </v-icon>
            </template>
            <span>Διεύθυνση παραλαβής-παράδοσης</span>
          </v-tooltip>
          <v-tooltip v-if="tab<2"  bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('edit-user', item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Επεξεργασία</span>
          </v-tooltip>
          <v-tooltip v-if="tab<2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('suspend-user', item, users.indexOf(item))">
               {{item.status_id==3? icons.mdiAccountCheck: icons.mdiAccountOff}}
              </v-icon>
            </template>
            <span>{{item.status_id==3? 'ενεργοποίηση' : 'σε παύση' }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="userType === 'drivers' && item.bus" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('unassign-bus', item)">
                mdi-fridge-industrial-off
              </v-icon>
              <v-icon v-else-if="userType === 'drivers'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('assign-bus', item)">
                mdi-bus
              </v-icon>
            </template>
            <span>{{item.bus? 'αφαίρεση σχολικού' : 'ανάθεση σχολικού' }}</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="userType === 'schools'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('login-as-school', item)">
                mdi-login
              </v-icon>
            </template>
            <span>Σύνδεση στο σχολείο</span>
          </v-tooltip>
          <v-tooltip v-if="tab!=2" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="userType === 'schools'" v-bind="attrs" v-on="on" small class="mr-2" @click="$emit('delete-school', item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Διαγραφή σχολείου</span>
          </v-tooltip>

        </template>
    </v-data-table>
    <RouteSelectionDialog @selection-confirmed="onRouteSelectionConfirmed" @selection-cancelled="onRouteSelectionCancelled" :display_dialog="route_dialog"
    :pick_up="selected_pick_up"
    :student_id="selected_student_id" :student_ids="selected_student_ids"></RouteSelectionDialog>
  </div>
</template>

<script>
import {
  mdiAccountCheck,
  mdiAccountOff,
} from "@mdi/js";
//import route-selection-dialog
import RouteSelectionDialog from "@/views/users/route-selection-dialog.vue";

export default {
  props: {
    users: Array,
    userType: String,
    tab: Number,
    mode: String,
  },
  components: {
    RouteSelectionDialog
  },
  data() {
    return {
      isLoading: false,
      selected_student_ids: [], // This will store just the IDs
      selected_students: [],
      search: "",
      defaultsHeaders: [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: "Όνομα", value: "name" },
        { text: "Email", value: "email" },
        { text: "Κατάσταση", value: "status_id" },
        { text: "Δημιουργήθηκε", value: "created_at" },
        { text: "Ενέργειες", value: "actions", sortable: false },
      ],
      driverHeaders: [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: "Όνομα", value: "name" },
        { text: "Email", value: "email" },
        { text: "Σχολικό", value: "bus" },
        { text: "Κατάσταση", value: "status_id" },
        { text: "Δημιουργήθηκε", value: "created_at" },
        { text: "Ενέργειες", value: "actions", sortable: false },
      ],
      studentAdvancedHeaders: [
        { text: "ID", value: "student_identification", align: "start", filterable: false },
        { text: "Όνομα", value: "name" },
        { text: "Όνομα Γονέα", value: "parent.name" },
        //{ text: "Email Γονέα", value: "parent.email" },
        //pickup stop
        { text: "Στάση παραλαβής", value: "student_details.pickup_stop" , align: "start", filterable: false, sortable: false},
        //drop off stop
        { text: "Στάση αποβίβασης", value: "student_details.drop_off_stop", align: "start", filterable: false, sortable: false },
        { text: "Κατάσταση", value: "status_id" },
        { text: "Δημιουργήθηκε", value: "created_at" },
        { text: "Ενέργειες", value: "actions", sortable: false },
      ],
      studentSimpleHeaders: [
        { text: "ID", value: "student_identification", align: "start", filterable: false },
        { text: "Όνομα", value: "name" },
        { text: "Όνομα Γονέα", value: "parent.name" },
        { text: "Email Γονέα", value: "parent.email" },
        //morning bus
        { text: "Πρωινό σχολικό", value: "student_settings.morning_bus" },
        //afternoon bus
        { text: "Απογευματινό σχολικό", value: "student_settings.afternoon_bus" },
        { text: "Κατάσταση", value: "status_id" },
        { text: "Δημιουργήθηκε", value: "created_at" },
        { text: "Ενέργειες", value: "actions", sortable: false },
      ],
      parentHeaders: [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: "Όνομα", value: "name" },
        { text: "Email", value: "email" },
        { text: "Ιδιότητα", value: "role_id" },
        { text: "Κατάσταση", value: "status_id" },
        { text: "Δημιουργήθηκε", value: "created_at" },
        { text: "Ενέργειες", value: "actions", sortable: false },
      ],
      statuses: [
        { value: "Ενεργό", color: "success" },
        { value: "υπο έλενχο", color: "warning" },
        { value: "σε παύση", color: "error" },
        { value: "Προς έλενχο", color: "error" },
        { value: "Ανεπαρκές υπόλοιπο", color: "error" },
      ],
      icons: {
        mdiAccountCheck,
        mdiAccountOff,
      },
      route_dialog: false,
      selected_student_id: null,
      selected_pick_up: null
    };
  },
  watch: {
    selected_students(newSelection) {
      // Update the selected_student_ids array whenever the selection changes
      this.selected_student_ids = newSelection.map(student => student.id);
    }
  },
  methods: {
    openRouteSelectionDialog(student_id, pick_up) {
      this.route_dialog = true;
      this.selected_student_id = student_id;
      this.selected_pick_up = pick_up;
    },
    onRouteSelectionConfirmed(data) {
      this.route_dialog = false;
      console.log(data);
      //emit
      this.$emit('route-selected', {
        studentId: data.studentId,
        studentIds: data.studentIds,
        routeId: data.routeId,
        stopId: data.stopId,
        pickup: data.pickup,
        tripId: data.tripId
      });
    },
    onRouteSelectionCancelled() {
      this.route_dialog = false;
    },
    getStatusColor(status)
    {
      return this.statuses[status-1].color;
    },
    getStatusValue(status)
    {
      return this.statuses[status-1].value;
    },
    getBusAssignmentColor(bus)
    {
        return bus != null? 'info': 'error';
    },
    getStopDetails(item, pickup)
    {
        if(pickup)
        {
            return item.student_settings.pickup_route_stop.route.name + '\n' + item.student_settings.pickup_route_stop.stop.name;
        }
        return item.student_settings.dropOffRouteStop;
    },
    tConvert(time) {
      if (time == null) {
        return null;
      }
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    getHeader()
    {
      if(this.userType === 'drivers') return this.driverHeaders;
      if(this.userType === 'students')
      {
            if(this.mode === 'simple'){
                return this.studentSimpleHeaders;
            }else{
                return this.studentAdvancedHeaders;
            }
      }
      if(this.userType === 'guardians') return this.parentHeaders;
      return this.defaultsHeaders;
    },
    checkIfLocationEnabled(item)
    {
        return this.userType === 'students' && item.student_settings != null && (item.student_settings.pickup_lat != null && item.student_settings.pickup_lng != null || item.student_settings.drop_off_lat != null && item.student_settings.drop_off_lng != null);
    }
  },
};
</script>
<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
